/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var GAME_STATES, PLAYER_STATES, PureRenderMixin, React, ReactDOM, _, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

_ = require('underscore');

css = require('../css/score.styl');

GAME_STATES = {
  LOBBY: 'lobby',
  RUNNING: 'running',
  OVER: 'over'
};

PLAYER_STATES = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  DEAD: 'dead'
};

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  getDefaultProps: function() {
    return {
      customClassNames: []
    };
  },
  displayName: 'Score',
  POINTS_TO_WIN: 10,
  isPlayerCzar: function(player) {
    var ref;
    return ((ref = this.props.game.players[this.props.game.czarIndex]) != null ? ref.id : void 0) === player.id;
  },
  getLabels: function(player) {
    var labels, playerPickedCards;
    labels = [];
    if (player.master) {
      labels.push(React.createElement("span", {
        "key": "master",
        "className": "label label-primary"
      }, "Master"));
    }
    if (player.points >= this.POINTS_TO_WIN) {
      labels.push(React.createElement("span", {
        "key": "winner",
        "className": "label label-warning"
      }, "Vítěz"));
    }
    if (player.state === PLAYER_STATES.DEAD) {
      labels.push(React.createElement("span", {
        "key": "dead",
        "className": "label label-default"
      }, "Opustil hru"));
    }
    if (this.props.game.state === GAME_STATES.RUNNING) {
      playerPickedCards = this.props.game.pickedCards[player.id] || [];
      if (player.state === PLAYER_STATES.ONLINE && !this.isPlayerCzar(player) && playerPickedCards.length < this.props.game.cardsRequired) {
        labels.push(React.createElement("span", {
          "key": "picking",
          "className": "label label-danger"
        }, "Vybírá karty"));
      }
      if (this.isPlayerCzar(player)) {
        labels.push(React.createElement("span", {
          "key": "czar",
          "className": "label label-info"
        }, "Czar"));
      }
    }
    return labels;
  },
  render: function() {
    var classes, list;
    classes = [css['score']].concat(this.props['customClassNames']);
    classes = classes.join(' ');
    list = _.sortBy(this.props.game.players, 'points').reverse().map((function(_this) {
      return function(player) {
        var playerClasses;
        playerClasses = [css['player-row']];
        if (player.id === _this.props.user.data.id) {
          playerClasses.push(css['player-me']);
        }
        playerClasses = playerClasses.join(' ');
        return React.createElement("div", {
          "key": player.id,
          "className": playerClasses
        }, React.createElement("span", {
          "className": css['player-name']
        }, player.nickname), React.createElement("span", {
          "className": css['player-score']
        }, player.points), React.createElement("span", {
          "className": css['player-labels']
        }, _this.getLabels(player)));
      };
    })(this));
    return React.createElement("div", {
      "className": classes
    }, list);
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "score.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/score.cjsx
 ** module id = 268
 ** module chunks = 0
 **/